export enum FORM_NAME {
  CREATE_CHAT_FUKUMARU = 'CREATE_CHAT_FUKUMARU',
  UPDATE_CHAT_FUKUMARU = 'UPDATE_CHAT_FUKUMARU',
}

